export default "__VITE_ASSET__B4e5R_eV__"